import { Card, CardContent, CardHeader, CardTitle } from '../ui/card'
import { Leaf, Factory, Truck, Package } from 'lucide-react'
import { CalculationProcessChainResponse } from 'store/types/assembler'

type EmissionSummaryProps = {
  totalEmissions?: number
  emissionsByCategory?: CalculationProcessChainResponse['emissionsByCategory']
}

export const EmissionSummary = ({
  totalEmissions,
  emissionsByCategory,
}: EmissionSummaryProps) => {
  const summaryCards = [
    {
      title: 'Total Emissions',
      value: (totalEmissions ?? 0).toFixed(5),
      unit: 'kg CO₂e',
      icon: Leaf,
      color: 'text-primary',
    },
    {
      title: 'Materials',
      value: (emissionsByCategory?.materials ?? 0).toFixed(5),
      unit: 'kg CO₂e',
      icon: Package,
      color: 'text-chart-2',
    },
    {
      title: 'Production',
      value: (emissionsByCategory?.production ?? 0).toFixed(5),
      unit: 'kg CO₂e',
      icon: Factory,
      color: 'text-chart-3',
    },
    {
      title: 'Logistics',
      value: (emissionsByCategory?.logistics ?? 0).toFixed(5),
      unit: 'kg CO₂e',
      icon: Truck,
      color: 'text-chart-4',
    },
  ]

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {summaryCards.map((card) => (
        <Card key={card.title}>
          <CardHeader className="flex flex-row items-center justify-between pb-2">
            <CardTitle className="text-sm font-medium text-muted-foreground">
              {card.title}
            </CardTitle>
            <card.icon className={`h-4 w-4 ${card.color}`} />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">{card.value}</div>
            <p className="text-xs text-muted-foreground mt-1">{card.unit}</p>
          </CardContent>
        </Card>
      ))}
    </div>
  )
}
